module.exports = require("@mui/icons-material/Pause");